import React from "react";

interface Props {
  message?: string;
}

const Loading: React.FC<Props> = ({ message = "Loading..." }) => (
  <div className="loading">
    <div className="spinner" />
    <p>{message}</p>
  </div>
);

export default Loading;
